// extracted by mini-css-extract-plugin
export default {"extension":"Extension_extension__YsfSA","checkbox":"Extension_checkbox__HqA0Q"};